import React from 'react';
import { Button, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import JapaneseDatePicker from '../../components/JapaneseDatePicker';
import moment from 'moment';
import { DAY_KANA, DATE_FORMAT, MONTHS } from '../../../utils/constants';

const SelectionHeader = (props) => {
    const MONTH_RANGE = 3;
    let maxDate = moment().add(MONTH_RANGE, MONTHS).endOf('month');
    let minDate = moment().subtract(MONTH_RANGE, MONTHS).startOf('month');
    let disableNext = moment(maxDate.format(DATE_FORMAT)).isSameOrBefore(props.filterDate);
    let disablePrev = moment(minDate.format(DATE_FORMAT)).isSameOrAfter(props.filterDate);

    return (
        <Col>
            <Col className="mobile-section-header">
                <span>
                    <div className="flex">
                        <Button className="button-toggle" onClick={props.setPrevDate} disabled={disablePrev}>
                            <FontAwesomeIcon icon={"caret-left"} />
                        </Button>

                        {' '}

                        <JapaneseDatePicker
                            name="filterDate"
                            noIcon={true}
                            mobile={true}
                            disableType={true}
                            readOnly={true}
                            onChange={props.handleDateChange.bind(this, "filterDate", DATE_FORMAT)}
                            onChangeRaw={props.handleDateChangeRaw}
                            selected={props.filterDate}
                            dateFormat={"納品日：MM月 DD日 (" + DAY_KANA[moment(props.filterDate).day()] + ")"}
                            className="clear-hidden"
                            minDate={minDate}
                            maxDate={maxDate}
                        />

                        {''}

                        <Button className="button-toggle" onClick={props.setNextDate} disabled={disableNext}>
                            <FontAwesomeIcon icon={"caret-right"} />
                        </Button>
                    </div>
                </span>
                <Button className="mobile-header-button" disabled={props.disableSubmit || props.noInput} onClick={props.handleSubmit}>確定</Button>
            </Col>
        </Col>
    );
};

export default SelectionHeader;